import { render, staticRenderFns } from "./HammamCenters.vue?vue&type=template&id=ff0aa37a&scoped=true&"
var script = {}
import style0 from "./HammamCenters.vue?vue&type=style&index=0&id=ff0aa37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0aa37a",
  null
  
)

export default component.exports